module.exports = __webpack_public_path__ + "img/analisis_promos.00d2ee5b.svg";